import jsonLd from '@/static/jsonld.json'
export default {
  validate ({ params }) {
    const checkParamsServiceIsNumber = () => {
      const paramsServiceIsNotNaN = !isNaN(params.service)
      return String(params.service).length > 0 && paramsServiceIsNotNaN
    }
    return checkParamsServiceIsNumber()
  },
  async asyncData ({ params, store, route, env }) {
    try {
      const serviceId = parseInt(params.service)
      const serviceDetails = await store.dispatch('service/getServiceInfo', { id: serviceId })
      await store.dispatch('service/getServiceOption', { id: serviceId })
      return {
        jsonLd,
        serviceDetails,
        serviceId,
        description: store.state.meta.description,
        category: params.category,
        categoryName: params.categoryName === 'star' ? '熱門服務' : params.categoryName,
        routeFullPath: route.fullPath,
        webBaseUrl: String(env.BASE_WEB_URL || ' ').slice(0, -1)
      }
    } catch (error) {
      console.log(error)
    }
  },
  async fetch () {
    try {
      let metaTag
      const getMetaTag = async () => {
        metaTag = await this.$store.dispatch('service/getServiceMetaTag', { id: this.serviceId })
      }
      const getRedirection = async () => {
        this.redirection = await this.$store.dispatch('service/getServiceRedirection', { id: this.serviceId })
      }
      await Promise.all([
        this.$store.dispatch('service/getSSRServiceScore', { id: this.serviceId }),
        this.$store.dispatch('service/getAllService'),
        getRedirection(),
        getMetaTag()
      ])
      const serviceMainRouteData = this.$nuxt.$router.resolve({
        name: 'category-category-service',
        params: {
          service: this.serviceId,
          category: this.category
        }
      })
      this.serviceMainUrl = this.webBaseUrl + serviceMainRouteData?.resolved?.fullPath
      let image = ''
      if (this.serviceDetails.image_file?.length > 1) {
        image = this.serviceDetails.image_file[1]
      } else if (this.serviceDetails.image_file?.length === 1) {
        image = this.serviceDetails.image_file[0]
      }
      if (image && image.substring(0, 5) === 'http:') {
        image = 'https:' + image.substring(5)
      }
      this.serviceName = this.serviceDetails.service_title
      this.category = this.category || this.serviceDetails.type_parent
      this.categoryName = this.getCategoryName(this.serviceDetails.type_parent)
      this.description = metaTag && metaTag.Description ? metaTag.Description : this.serviceDetails.service_desc || this.description
      this.keywords = metaTag?.Keywords || null
      this.metaTitle = metaTag?.Title || null
      this.image = image
      this.isOpen = this.serviceDetails.is_check === 1 && this.serviceDetails.is_web
    } catch (error) {
      console.log(error)
    }
  }
}
